import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconFrequency: React.FC<IconBaseProps> = ({
  size = 12,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 12;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 12 12"
      {...props}
    >
      <path
        d="M10.6667 10.6567V9.80575C10.2141 10.3466 9.66885 10.809 9.05013 11.1664C7.89791 11.8321 6.55867 12.1004 5.23893 11.9301C3.91922 11.7598 2.69226 11.16 1.74674 10.2237C0.860246 9.34584 0.267095 8.21764 0.0455729 6.9939L0.00651042 6.74846L0.000651042 6.6801C-0.0117374 6.34249 0.233023 6.04337 0.57487 5.99586C0.916828 5.94834 1.23444 6.16943 1.31445 6.49781L1.32682 6.56487L1.35742 6.75627C1.53024 7.7111 1.9932 8.59148 2.6849 9.27646C3.4226 10.0069 4.37987 10.475 5.40951 10.6078C6.43917 10.7407 7.48384 10.5308 8.38281 10.0115C8.97404 9.66993 9.47996 9.20636 9.87109 8.65667H8.66667C8.29854 8.65667 8.00011 8.3581 8 7.99C8 7.62181 8.29848 7.32333 8.66667 7.32333H10.9857C10.9937 7.32316 11.0017 7.32322 11.0098 7.32333H11.3333C11.7015 7.32333 12 7.62181 12 7.99V10.6567C11.9999 11.0248 11.7015 11.3233 11.3333 11.3233C10.9652 11.3233 10.6668 11.0248 10.6667 10.6567ZM2.94987 0.813566C4.1021 0.147907 5.44132 -0.120396 6.76107 0.0498942C8.08072 0.220173 9.30776 0.819405 10.2533 1.75562C11.1397 2.63345 11.7329 3.76181 11.9544 4.98544L11.9935 5.23154L11.9993 5.29924C12.0119 5.63696 11.7671 5.93596 11.4251 5.98349C11.0833 6.03099 10.7657 5.81036 10.6855 5.48219L10.6732 5.41513L10.6426 5.22307C10.4697 4.26834 10.0067 3.3878 9.3151 2.70289C8.57743 1.97249 7.62006 1.50502 6.59049 1.37216C5.56087 1.2393 4.51614 1.44858 3.61719 1.96786C3.02576 2.30954 2.51944 2.77339 2.12826 3.32333H3.33333C3.70152 3.32333 4 3.62181 4 3.99C3.99989 4.3581 3.70146 4.65667 3.33333 4.65667H0.666667C0.298542 4.65667 0.000105807 4.3581 0 3.99V1.32333C0 0.955142 0.298477 0.656665 0.666667 0.656665C1.03486 0.656665 1.33333 0.955142 1.33333 1.32333V2.17294C1.78578 1.63242 2.33142 1.17088 2.94987 0.813566Z"
        fill={color}
      />
    </IconBase>
  );
};

export default IconFrequency;
